<script>
export default {
  props: {
    pagination: {
      type: Object,
      default: null,
    },
  },

  methods: {
    onChangePage(page) {
      this.$emit('change', page)
    },
  },
}
</script>

<template>
  <div
    v-if="pagination && pagination.totalPages > 1"
    class="mt-8 text-center"
    data-cypress-pagination
  >
    <span
      v-for="page in pagination.totalPages"
      :key="page"
      class="border py-2 px-3 mx-1 rounded cursor-pointer inline-block mb-2"
      :class="{ 'bg-gray-200': page === pagination.currentPage }"
      @click="onChangePage(page)"
      >{{ page }}</span
    >
  </div>
</template>
